// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x } from '@wordpress/i18n';

import { recipeSetRequiresUser } from '@automator/builder/_legacy/js/common/utilities';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'ua-builder-user-selector-set-data-dialog' )
export class SetUserDataDialog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Get main elements
	@query( 'uo-dialog' ) accessor $dialog;

	@query( '#confirm-button' ) accessor $confirmButton;

	// eslint-disable-next-line require-jsdoc, no-useless-constructor
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-dialog
				heading="${ escapeHTML( __( 'We need some user data', 'uncanny-automator' ) ) }"
				open
			>
				<div class="set-data-dialog">
					<div class="set-data-dialog-summary">
						<slot name="summary"></slot>
					</div>
					
					<div class="set-data-dialog-box">
						<slot name="box"></slot>
					</div>

					<div class="set-data-dialog-description">
						<slot name="description"></slot>
					</div>
				</div>

				<uo-button
					slot="primary-action"
					id="confirm-button"

					@click=${ this.confirmAction }
				>
					${ escapeHTML( __( 'Set user data', 'uncanny-automator' ) ) }
				</uo-button>

				<uo-button
					slot="secondary-action"
					dialog-action="close"
					color="secondary"

					@click=${ this.cancelAction }
				>
					${ escapeHTML( _x( 'Cancel', 'Verb', 'uncanny-automator' ) ) }
				</uo-button>
			</uo-dialog>
		`;
	}

	/**
	 * Callback invoked when the user confirms that it wants to add user data
	 *
	 * @return {undefined}
	 */
	confirmAction() {
		// Add loading animation to the confirm button
		this.$confirmButton.loading = true;

		// Do call to request the user data
		recipeSetRequiresUser(
			true,

			// On success
			() => {
				// Trigger custom event
				this.dispatchEvent(
					( new CustomEvent( 'automator_user-selector_request-data-dialog_confirm_success' ) )
				);

				// Remove loading animation to the confirm button
				this.$confirmButton.loading = false;

				// Destroy this element
				this.parentNode.removeChild( this );
			},

			// On fail
			() => {
				// Trigger custom event
				this.dispatchEvent(
					( new CustomEvent( 'automator_user-selector_request-data-dialog_confirm_fail' ) )
				);

				// Remove loading animation to the confirm button
				this.$confirmButton.loading = false;
			}
		);
	}

	/**
	 * Callback invoked when the user cancels the action
	 *
	 * @return {undefined}
	 */
	cancelAction() {
		// Destroy this element
		this.parentNode.removeChild( this );

		// Trigger custom event
		this.dispatchEvent(
			( new CustomEvent( 'automator_user-selector_request-data-dialog_cancel' ) )
		);
	}
}
